module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoggedIn) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "30px"
    }
  }, [(_vm.success) ? _c('div', {
    staticClass: "col-sm-12 center-div final-cont text-center"
  }, [_c('img', {
    attrs: {
      "src": "images/ok.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Rendelésedet rögzítettük, visszaigazoló emailt küldtünk az email címedre, hamarosan felvesszük veled a kapcsolatot.")])]) : _vm._e(), _vm._v(" "), (_vm.fail) ? _c('div', {
    staticClass: "col-sm-12 center-div final-cont text-center"
  }, [_c('h2', [_vm._v("Hiba történt a fizetés során. Ha úgy gondolod hogy fizetésed mégis érvényes volt, kérlek vedd fel velünk a kapcsolatot.")])]) : _vm._e()])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80aee20e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/checkout/FlowFinal.vue
// module id = 122
// module chunks = 0 1 2